import {wrap} from '../../shared/loading-overlay.js'
const PreferencesController = (
  $scope,
  $uibModal,
  logger,
  CandidatePreferencesApi,
  CandidateProfileApi
) => {
  $scope.resetEditPreferences = () => {
    $scope.editPreferences = {
      contracts: angular.copy($scope.candidate.preferredContractTypes),
      occupations: angular.copy($scope.candidate.occupations),
      employerTypes: angular.copy($scope.candidate.legalEmployerTypes),
    }
  }

  $scope.updateEmployerTypes = async () => {
    const employerTypes = $scope.editPreferences.employerTypes
      .filter(employerType => employerType.isSelected)
      .map(employerType => employerType.id)
    await wrap(async () =>
      CandidatePreferencesApi.updateCandidatePreferences($scope.candidate.id, {
        specialtiesByCategory: [{id: 2, specialties: employerTypes}],
      })
    )
    $scope.candidate.legalEmployerTypes = $scope.editPreferences.employerTypes
    $scope.resetEditPreferences()
    $scope.$apply()
    logger.notify('success', 'Successfully Updated employer types')
  }

  $scope.updateContracts = async () => {
    const contracts = $scope.editPreferences.contracts
      .filter(employerType => employerType.isSelected)
      .map(employerType => employerType.id)
    await wrap(async () =>
      CandidatePreferencesApi.updateCandidatePreferences($scope.candidate.id, {
        preferredContractTypes: contracts,
      })
    )
    $scope.candidate.preferredContractTypes = $scope.editPreferences.contracts
    $scope.resetEditPreferences()
    $scope.$apply()
    logger.notify('success', 'Successfully Updated contracts')
  }

  $scope.updateOccupations = async () => {
    const occupations = $scope.editPreferences.occupations
      .filter(employerType => employerType.isSelected)
      .map(employerType => employerType.id)
    await wrap(async () =>
      CandidatePreferencesApi.updateCandidatePreferences($scope.candidate.id, {
        occupations,
      })
    )
    $scope.candidate.occupations = $scope.editPreferences.occupations
    $scope.resetEditPreferences()
    $scope.$apply()
    logger.notify('success', 'Successfully Updated occupations')
  }

  $scope.unHideEmployer = async candidateHidden => {
    await CandidateProfileApi.unHideEmployer(
      candidateHidden.userId,
      candidateHidden.employerId
    )
    logger.notify(
      'success',
      `Successfully unhidden employer: ${candidateHidden.employer.name}`
    )
    candidateHidden.hide = false
    $scope.$apply()
  }

  $scope.updateEmailPause = async emailType => {
    if (
      $scope.candidate &&
      $scope.candidate.emailSubscriptions &&
      $scope.candidate.emailSubscriptions[emailType] &&
      $scope.candidate.emailSubscriptions[emailType].paused
    ) {
      await wrap(async () =>
        CandidateProfileApi.pauseEmail($scope.candidate.id, emailType)
      )
      logger.notify('success', `Successfully paused email subscription`)
    } else {
      await wrap(async () =>
        CandidateProfileApi.unpauseEmail($scope.candidate.id, emailType)
      )
      logger.notify('success', `Successfully un paused email subscription`)
    }

    $scope.$applyAsync()
  }

  $scope.updateEmailSubscription = async emailType => {
    if (
      $scope.candidate &&
      $scope.candidate.emailSubscriptions &&
      $scope.candidate.emailSubscriptions[emailType] &&
      $scope.candidate.emailSubscriptions[emailType].stopped
    ) {
      await wrap(async () =>
        CandidateProfileApi.subscribe($scope.candidate.id, emailType)
      )
      logger.notify('success', `Successfully subscribed to email ping`)
    } else {
      await wrap(async () =>
        CandidateProfileApi.unsubscribe($scope.candidate.id, emailType)
      )
      logger.notify('success', `Successfully unsubscribed to email ping`)
    }

    $scope.$applyAsync()
  }

  $scope.openLocationModal = (selectedLocations, event) => {
    event.preventDefault()
    event.stopPropagation()

    const modalInstance = $uibModal.open({
      templateUrl: 'locations-modal.html',
      controller: 'LocationsModalController',
      controllerAs: 'ctrl',
      resolve: {
        locationList: function() {
          return $scope.locations.filter(({supported}) => supported)
        },
        selectedLocations: function() {
          return $scope.candidate.preferredLocations
        },
        limit: function() {
          return 0
        },
        locationModalHeading: function() {
          return false
        },
        displayNextButton: function() {
          return false
        },
      },
    })
    modalInstance.result.then(
      async selectedLocations => {
        $scope.candidate.preferredLocations = angular.copy(selectedLocations)
        await wrap(async () =>
          CandidatePreferencesApi.updateCandidatePreferences(
            $scope.candidate.id,
            {
              preferredLocations: selectedLocations.map(
                location => location.id
              ),
            }
          )
        )
        logger.notify('success', `Successfully updated preferred locations`)
      },
      () => {}
    )
  }

  $scope.initializePreferencesData = async () => {
    if (!$scope.preferredLocation) {
      const {data} = await CandidateProfileApi.getUserProfile(
        $scope.candidate.id,
        {
          include: ['preferredLocations'],
        }
      )
      $scope.candidate.preferredLocations = data ? data.preferredLocations : []
    }

    Promise.all([
      CandidateProfileApi.getEmailSubscriptions($scope.candidate.id),
      CandidateProfileApi.getUserFollowEmployers($scope.candidate.id),
      CandidateProfileApi.getUserHiddenEmployers($scope.candidate.id),
    ]).then(result => {
      // eslint-disable-next-line unicorn/no-reduce
      $scope.candidate.emailSubscriptions = result[0].data.reduce(
        (accumulator, current) => {
          accumulator[current.emailId] = current
          return accumulator
        },
        {}
      )
      $scope.candidate.candidateFollow = result[1].data
      $scope.candidate.candidateHidden = result[2].data
      $scope.$apply()
    })
  }

  $scope.initializePreferencesData()
}

export {PreferencesController}



// WEBPACK FOOTER //
// ./scripts/candidate-profile/preferences/preferences.ctrl.js